import { useMemo } from 'react';
import { filterAgentsByUserAccess } from '../utils/agentAccess';
import useAuth from './useAuth';

export function useAccessibleAgentsFilter<T>(agents: T[]): {
  data: T[];
  isAccessLoading: boolean;
} {
  const { currentUser } = useAuth();

  const filteredAgents = useMemo(
    () => filterAgentsByUserAccess(currentUser, agents, []),
    [agents, currentUser]
  );

  return { data: filteredAgents, isAccessLoading: false };
}
